import { deepArticles } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function DeepRead() {
  return (
    <section id="deep" className="scroll-mt-28 py-12 md:py-16 bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          kicker="DEEP READ"
          kickerZh="不止于热闹"
          title="深度阅读：把瓜背后的逻辑讲清楚"
          desc="热点转瞬即逝，但套路会长存。这一栏目围绕行业规则、资本运作与叙事方法做深入拆解，帮你建立自己的判断框架，越吃越明白。"
        />

        <div className="flex flex-col gap-6">
          {deepArticles.map((a, i) => (
            <article
              key={a.id}
              className="group grid overflow-hidden rounded-xl border border-background-800 bg-background-950/60 md:grid-cols-2"
            >
              <div className={`relative overflow-hidden ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                <img
                  src={a.img}
                  alt={`${a.title}深度专题配图`}
                  className="h-60 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-full"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50 whitespace-nowrap">
                  <i className="ri-article-line"></i>
                  {a.tag}
                </span>
              </div>
              <div className={`flex flex-col justify-center p-6 md:p-10 ${i % 2 === 1 ? 'md:order-1' : ''}`}>
                <div className="flex items-center gap-3 text-xs">
                  <span className="font-label text-accent-300 tracking-widest uppercase">
                    Special · {String(a.id).padStart(2, '0')}
                  </span>
                  <span className="text-background-50/50 whitespace-nowrap">
                    <i className="ri-time-line mr-1"></i>
                    {a.read} 读完
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold leading-snug text-background-50 group-hover:text-accent-300">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm md:text-[15px] leading-7 text-background-50/75">{a.excerpt}</p>
                <a
                  href="#feed"
                  className="mt-5 inline-flex w-max items-center gap-2 rounded-md border border-background-700 px-4 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  相关延伸阅读
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}